import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { refreshResidenteUserAction } from "../store/actions/AuthActions";

/**
 * Hook para cargar datos frescos del residente cuando se hace reload (F5).
 *
 * Al recargar la página, el store de Redux queda vacío. Este hook detecta
 * que el usuario es RESIDENTE y llama al endpoint /api/v3/residentes/auth/me/
 * para obtener datos frescos del backend y actualizar el store antes de
 * renderizar el contenido de la pantalla.
 *
 * @returns {{ isInitialized: boolean, isLoading: boolean }}
 */
export const useResidenteDataInit = () => {
  const dispatch = useDispatch();

  const access = useSelector((state) => state.auth.auth.access);
  const tipo = useSelector((state) => state.auth.auth.user?.tipo);

  const [isLoading, setIsLoading] = useState(true);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const isResidente = !!access && tipo === "RESIDENTE";

    if (!isResidente) {
      setIsInitialized(true);
      setIsLoading(false);
      return;
    }

    // Llamar al backend para obtener datos frescos del residente.
    // Esto garantiza que perfil_residente, vivienda, unidad_residencial, etc.
    // estén siempre actualizados después de un F5 / reload de página.
    Promise.resolve(dispatch(refreshResidenteUserAction()))
      .then(() => {
        setIsInitialized(true);
        setIsLoading(false);
      })
      .catch(() => {
        // Si falla la carga, continuar igual para no bloquear la app.
        setIsInitialized(true);
        setIsLoading(false);
      });
  }, [access, tipo]); // eslint-disable-line

  return { isInitialized, isLoading };
};

export default useResidenteDataInit;
